export const TOP_RIGHT = 'top-right';
export const SUCCESS = 'success';
export const ERROR = 'error';

export const HOTJAR_SESSION = 'hotjar_session';

export const SURVEY_SESSION = 'survey_session';
export const POSTHOG_API_KEY = 'phc_l5mPCJTICc1pN0UlkHAAFhBYBF2MfqDRPB6LLv9zsZd';
export const POSTHOG_API_HOST = 'https://us.i.posthog.com';
export const CSAT_ID = '01948d4e-5bec-0000-2357-a921eab7c171';
export const NPS_ID = '0194a6d4-a232-0000-2153-4c0f88e2bcad';

export const EDIT_MODE = 'EDIT_MODE';

const url = window.location.href;
const id = url.replace(window.location.protocol + '//', '').split('.')[0];

const school_id =
  id.substring(0, 10) === 'localhost:'
    ? id.substring(0, 14) === 'localhost:5000'
      ? 'safsims'
      : 'ICS'
    : id;

export { school_id };
